

/**
 * Defines scroll infomations like top, left and width, height
 * The width/height is the max value for the scrollTop/scrollLeft value.
 */
export interface ScrollInfo {
	top:number;
	height:number;
	left:number;
	width:number;
}

/**
 * Defines a dimension with width & height
 */
export interface Dimension {
	height:number;
	width:number;
}



/**
 * Returns the scroll top position of the window/body.
 */
export function scrollInfo():ScrollInfo {

	var e = document.documentElement;
	var b = document.body;
	var doc = documentDimension();
	var view = viewportDimension();

	return {
		top: ( e && e.scrollTop ) || b.scrollTop,
		left: ( e && e.scrollLeft ) || b.scrollLeft,
		width: doc.width - view.width,
		height: doc.height - view.height
	}
}

/**
 * Returns the dimensions of the document without the scrollbars
 */
export function documentDimension():Dimension {
	return {
		width: document.documentElement.offsetWidth || document.body.offsetWidth,
		height: Math.max(		// Hack for IE 10 document height
			document.body.scrollHeight, document.documentElement.scrollHeight,
			document.body.offsetHeight, document.documentElement.offsetHeight,
			document.body.clientHeight, document.documentElement.clientHeight
		)
	}
}


/**
 * Returns the dimensions of the viewport including the scrollbars
 */
export function viewportDimension():Dimension {
	return {
		width: window.innerWidth || document.body.clientWidth,
		height: window.innerHeight || document.body.clientHeight
	}
}

/**
 * Returns the bounding box of this node including values for top, bottom, left, right relative to the current viewport
 */
export function relativeBounds( node:Element ) {
	let c = node.getBoundingClientRect();
	let r = {  top: c.top, left: c.left, right: c.right, bottom: c.bottom, height: c.height, width: c.width };

	if ( r.height == undefined ) r.height = r.bottom - r.top;
	if ( r.width == undefined ) r.width = r.right - r.left;

	return r;
}

/**
 * Returns the bounding box of this node including values for top, bottom, left, right in absolute document coordinates
 */
export function absoluteBounds( node:Element ) {
	let box = relativeBounds( node );

	box.top += document.body.scrollTop || document.documentElement.scrollTop;
	box.bottom += document.body.scrollTop || document.documentElement.scrollTop;
	box.left += document.body.scrollLeft || document.documentElement.scrollLeft;
	box.right += document.body.scrollLeft || document.documentElement.scrollLeft;

	return box;
}
